// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"79de738b","442":"c8a0eae1","821":"5f65d4b9"}[chunkId] + ".chunk.js";
};